<script setup lang="ts">
import { useModalPageWrapper } from '@modules/core/components/ModalPageWrapper/composables';
import ModalPageWrapper from '@modules/core/components/ModalPageWrapper/ModalPageWrapper.vue';
import PlayerProfilePage from '@modules/players/submodules/PlayerProfile/pages/PlayerProfilePage/PlayerProfilePage.vue';

import type { IPlayersProfileDialogProps } from '../../types';

defineProps<IPlayersProfileDialogProps>();

const { showPageDialog, closePageDialog } = useModalPageWrapper();
</script>

<template>
  <div v-data-qa-auto-id="'PlayerProfileDialogPage'">
    <ModalPageWrapper
      :show-dialog="showPageDialog"
      :back-to="backTo"
      @hide="closePageDialog"
    >
      <PlayerProfilePage
        :main-data-route="mainDataRoute"
        :activity-route="activityRoute"
        :tracker-route="trackerRoute"
        :edit-history-route="editHistoryRoute"
      />
    </ModalPageWrapper>
  </div>
</template>
